import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import EmptyDataMessage from './EmptyDataMessage.component';
import { DashboardDetail } from '../../detail/DashboardDetail';
import { DetailConf } from '../../../module/yachtDashboard/conf/booking/Detail.conf';
import { COLOR_TAB_BOOKING } from '../../../module/yachtDashboard/conf/Data.conf';

const BookingTabContent = ({ bookings }) => {
  const { fields, formatValue } = DetailConf;
  return (
    <Box sx={{ minHeight: '55vh' }}>
      {!_.isEmpty(bookings) ? (
        bookings.map((booking) => {
          const data = {
            ...booking,
            attributes: {
              ...booking?.attributes,
              id_marina: {
                data: {
                  attributes: {
                    ..._.get(booking, 'attributes.id_marina.data.attributes'),
                    marina:
                      _.get(
                        booking,
                        'attributes.id_marina.data.attributes.marina'
                      ) || '-',
                    location:
                      _.get(
                        booking,
                        'attributes.id_marina.data.attributes.location'
                      ) || '-',
                  },
                },
              },
            },
          };

          return (
            <Link
              to={`/booking/${booking.id}`}
              key={booking.id}
              style={{ textDecoration: 'none' }}
            >
              <DashboardDetail
                fields={fields}
                data={data}
                render={formatValue}
                colorTab={COLOR_TAB_BOOKING}
              />
            </Link>
          );
        })
      ) : (
        <EmptyDataMessage message='No bookings found' />
      )}
    </Box>
  );
};

export default BookingTabContent;
